import {
   extractCreatedReservations,
   getReservationColumnInstructorId,
   getReservationStudentId,
   reservationIdFromAny,
} from "../ultra/reservationRowUtils";

/**
 * Prefer a real id returned by POST /reservations/for-user.
 * Falls back to null when the envelope has no usable created row.
 */
export function resolveCreatedReservationId(
   createResult,
   { userId, instructorId } = {},
) {
   const created = extractCreatedReservations(createResult);
   if (!created.length) return { confirmedId: "", candidate: null, source: "empty" };

   const expectedUser = String(userId ?? "").trim();
   const expectedInstructor = String(instructorId ?? "").trim();

   const withId = created.filter((row) => Boolean(reservationIdFromAny(row)));
   if (!withId.length) {
      return { confirmedId: "", candidate: null, source: "empty" };
   }

   if (expectedUser || expectedInstructor) {
      const strict = withId.filter((row) => {
         const studentOk =
            !expectedUser ||
            String(getReservationStudentId(row) ?? "").trim() === expectedUser;
         const instructorOk =
            !expectedInstructor ||
            String(getReservationColumnInstructorId(row) ?? "").trim() ===
               expectedInstructor;
         return studentOk && instructorOk;
      });
      if (strict.length === 1) {
         return {
            confirmedId: String(reservationIdFromAny(strict[0])),
            candidate: strict[0],
            source: "create-strict",
         };
      }
      // Ambiguous create envelopes must not promote a foreign reservation id
      // onto the optimistic cell — leave delta/socket reconcile to finish.
      if (strict.length > 1) {
         return {
            confirmedId: "",
            candidate: null,
            source: "create-strict-ambiguous",
         };
      }
   }

   if (withId.length === 1) {
      return {
         confirmedId: String(reservationIdFromAny(withId[0])),
         candidate: withId[0],
         source: "create-single",
      };
   }

   return {
      confirmedId: "",
      candidate: null,
      source: "create-ambiguous",
   };
}
